// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------------new design--------------------*/

.Pv_RaLx2CUCVf9i6uEjY {
    padding: 16px 10px 17px 10px;
    cursor: pointer;
    border-radius: 24px;
    margin-bottom: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    position: relative;
    width: 100%;
    transition: background ease-in-out 0.2s;
    transform: translateZ(0);
}

.Pv_RaLx2CUCVf9i6uEjY:active {
    background: rgba(var(--placeholder-tertiary), 0.2);
}

/* .item:hover {
  background: rgba(var(--placeholder-tertiary), 0.2);
} */

.Pv_RaLx2CUCVf9i6uEjY:not(:last-child)::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 0.7px;
    bottom: -2px;
    right: 0;
    background: rgba(116, 116, 128, 1);
    opacity: 0.15;
}

.jpZfy5ddCG9tQOeS3mWT {
    display: flex;
    align-items: center;
    gap: 10px;
}

.WL5UtZAooHDFvYJWMfd9 {
    position: relative;
}

._kzFAm96vXg4r1pG3FqS {
    position: absolute;
    top: -6px;
    right: -2px;
    width: 20px !important;
    height: 20px !important;
}

.PqpuhzDuOEBhcO4u9qFm {
    font-size: 17px;
    line-height: 129%;
    letter-spacing: 0.43px;
}

@media (max-width: 321px) {
    .PqpuhzDuOEBhcO4u9qFm {
        font-size: 14px;
    }
    .KMAlP9HVQqi3zMmCdZEJ > span {
        padding-left: 2px;
        font-size: 11px;
    }
    .WL5UtZAooHDFvYJWMfd9 > img {
        width: 32px;
        height: 32px;
        border-radius: 50%;
    }
    .KMAlP9HVQqi3zMmCdZEJ {
        font-size: 13px;
    }
    .YnZL4Gtm3K7JIIE90qWr {
        font-size: 13px;
    }
}
@media (min-width: 322px) {
    .PqpuhzDuOEBhcO4u9qFm {
        font-size: 15px;
    }
    .KMAlP9HVQqi3zMmCdZEJ > span {
        padding-left: 3px;
        font-size: 12px;
    }
    .WL5UtZAooHDFvYJWMfd9 > img {
        width: 34px;
        height: 34px;
        border-radius: 50%;
    }
    .KMAlP9HVQqi3zMmCdZEJ {
        font-size: 14px;
    }
    .YnZL4Gtm3K7JIIE90qWr {
        font-size: 14px;
    }
}
@media (min-width: 412px) {
    .PqpuhzDuOEBhcO4u9qFm {
        font-size: 16px;
    }
    .KMAlP9HVQqi3zMmCdZEJ > span {
        padding-left: 3px;
        font-size: 13px;
    }
    .WL5UtZAooHDFvYJWMfd9 > img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
    }
    .KMAlP9HVQqi3zMmCdZEJ {
        font-size: 15px;
    }
    .YnZL4Gtm3K7JIIE90qWr {
        font-size: 15px;
    }
}
@media (min-width: 512px) {
    .PqpuhzDuOEBhcO4u9qFm {
        font-size: 17px;
    }
    .KMAlP9HVQqi3zMmCdZEJ > span {
        padding-left: 3px;
        font-size: 13px;
    }
    .WL5UtZAooHDFvYJWMfd9 > img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }
    .KMAlP9HVQqi3zMmCdZEJ {
        font-size: 16px;
    }
    .YnZL4Gtm3K7JIIE90qWr {
        font-size: 16px;
    }
}

.KMAlP9HVQqi3zMmCdZEJ {
    color: rgb(var(--placeholder-secondary));
}

.TxJku5buKUzK6bIbbiK0 {
    text-align: right;
}

.YnZL4Gtm3K7JIIE90qWr {
    text-align: right;
}

/*--------------------/new design--------------------*/
`, "",{"version":3,"sources":["webpack://./src/pages/main/assets/asset-item/asset-item.module.css"],"names":[],"mappings":"AAAA,qDAAqD;;AAErD;IACI,4BAA4B;IAC5B,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,uCAAuC;IACvC,wBAAwB;AAC5B;;AAEA;IACI,kDAAkD;AACtD;;AAEA;;GAEG;;AAEH;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,YAAY;IACZ,QAAQ;IACR,kCAAkC;IAClC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,sDAAsD","sourcesContent":["/*--------------------new design--------------------*/\n\n.item {\n    padding: 16px 10px 17px 10px;\n    cursor: pointer;\n    border-radius: 24px;\n    margin-bottom: 4px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    position: relative;\n    width: 100%;\n    transition: background ease-in-out 0.2s;\n    transform: translateZ(0);\n}\n\n.item:active {\n    background: rgba(var(--placeholder-tertiary), 0.2);\n}\n\n/* .item:hover {\n  background: rgba(var(--placeholder-tertiary), 0.2);\n} */\n\n.item:not(:last-child)::before {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 0.7px;\n    bottom: -2px;\n    right: 0;\n    background: rgba(116, 116, 128, 1);\n    opacity: 0.15;\n}\n\n.itemInfo {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.itemImg {\n    position: relative;\n}\n\n.itemTokenGraph {\n    position: absolute;\n    top: -6px;\n    right: -2px;\n    width: 20px !important;\n    height: 20px !important;\n}\n\n.itemToken {\n    font-size: 17px;\n    line-height: 129%;\n    letter-spacing: 0.43px;\n}\n\n@media (max-width: 321px) {\n    .itemToken {\n        font-size: 14px;\n    }\n    .itemAmount > span {\n        padding-left: 2px;\n        font-size: 11px;\n    }\n    .itemImg > img {\n        width: 32px;\n        height: 32px;\n        border-radius: 50%;\n    }\n    .itemAmount {\n        font-size: 13px;\n    }\n    .itemAmountUsd {\n        font-size: 13px;\n    }\n}\n@media (min-width: 322px) {\n    .itemToken {\n        font-size: 15px;\n    }\n    .itemAmount > span {\n        padding-left: 3px;\n        font-size: 12px;\n    }\n    .itemImg > img {\n        width: 34px;\n        height: 34px;\n        border-radius: 50%;\n    }\n    .itemAmount {\n        font-size: 14px;\n    }\n    .itemAmountUsd {\n        font-size: 14px;\n    }\n}\n@media (min-width: 412px) {\n    .itemToken {\n        font-size: 16px;\n    }\n    .itemAmount > span {\n        padding-left: 3px;\n        font-size: 13px;\n    }\n    .itemImg > img {\n        width: 36px;\n        height: 36px;\n        border-radius: 50%;\n    }\n    .itemAmount {\n        font-size: 15px;\n    }\n    .itemAmountUsd {\n        font-size: 15px;\n    }\n}\n@media (min-width: 512px) {\n    .itemToken {\n        font-size: 17px;\n    }\n    .itemAmount > span {\n        padding-left: 3px;\n        font-size: 13px;\n    }\n    .itemImg > img {\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n    }\n    .itemAmount {\n        font-size: 16px;\n    }\n    .itemAmountUsd {\n        font-size: 16px;\n    }\n}\n\n.itemAmount {\n    color: rgb(var(--placeholder-secondary));\n}\n\n.itemAmountRight {\n    text-align: right;\n}\n\n.itemAmountUsd {\n    text-align: right;\n}\n\n/*--------------------/new design--------------------*/\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": `Pv_RaLx2CUCVf9i6uEjY`,
	"itemInfo": `jpZfy5ddCG9tQOeS3mWT`,
	"itemImg": `WL5UtZAooHDFvYJWMfd9`,
	"itemTokenGraph": `_kzFAm96vXg4r1pG3FqS`,
	"itemToken": `PqpuhzDuOEBhcO4u9qFm`,
	"itemAmount": `KMAlP9HVQqi3zMmCdZEJ`,
	"itemAmountUsd": `YnZL4Gtm3K7JIIE90qWr`,
	"itemAmountRight": `TxJku5buKUzK6bIbbiK0`
};
export default ___CSS_LOADER_EXPORT___;
